export interface CookieOespInfoInterface{
    nome: string,
    email: string,
    id: number,
    sobre_nome: string,
    cpf?: string
}

export function isValidCookie(oesp_info: CookieOespInfoInterface) {
    if(!isValidEmail(oesp_info?.email)) {
        return false
    } else if (isValidEmail(oesp_info?.email)){
        return true;
    }
    if(oesp_info?.id <= 0) {
        return false
    }
    if(oesp_info?.nome?.length <= 0) {
        return false
    }
    if(oesp_info?.sobre_nome?.length <= 0) {
        return false
    }
    return !!oesp_info
}

function isValidEmail(email: string) {
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
}
